document.addEventListener('DOMContentLoaded', function() {
    const clickElement = document.querySelector('.rebuy-click');
    const dropdownContainer = document.querySelector('.rebuy-quick-view-dropdown__container');
    const searchButton = document.querySelector('.rebuy-btn');

    if (clickElement && dropdownContainer) {
        clickElement.addEventListener('click', function() {
            dropdownContainer.classList.toggle('visible');
            clickElement.style.display = 'none';

            // Now that the dropdown is visible, select the search input
            const searchInput = document.querySelector('#searchInput');

            if (searchButton && searchInput) {
                searchButton.addEventListener('click', function() {
                    const query = searchInput.value.trim();
                    if (query) {
                        window.location.href = `/search?q=${encodeURIComponent(query)}`;
                    }
                });
            }
        });
    }
});
